import { render, staticRenderFns } from "./PatientTreatment.vue?vue&type=template&id=8b7b6bf2&scoped=true&"
import script from "./PatientTreatment.vue?vue&type=script&lang=js&"
export * from "./PatientTreatment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b7b6bf2",
  null
  
)

export default component.exports